'use client'

import { z } from 'zod'

const browserSupabaseConfigSchema = z
  .object({
    data: z
      .object({
        key: z.string().min(1),
        url: z.string().url()
      })
      .strict(),
    success: z.literal(true)
  })
  .strict()

export type BrowserSupabaseRuntimeConfig = z.infer<typeof browserSupabaseConfigSchema>['data']

let configPromise: Promise<BrowserSupabaseRuntimeConfig> | null = null

export function loadBrowserSupabaseRuntimeConfig(): Promise<BrowserSupabaseRuntimeConfig> {
  if (configPromise) return configPromise

  configPromise = fetch('/api/auth/browser-config', {
    cache: 'no-store',
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  })
    .then(async (response) => {
      const payload = await response.json().catch(() => null)
      const parsed = browserSupabaseConfigSchema.safeParse(payload)
      if (!response.ok || !parsed.success) {
        throw new Error('Browser authentication is temporarily unavailable.')
      }
      return parsed.data.data
    })
    .catch((error) => {
      configPromise = null
      throw error
    })

  return configPromise
}
